import React from "react";

const FlipPanelHeader = ({ onClose, title = "Content Tools" }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
      <h5 className="mb-0 fw-bold text-primary">{title}</h5>
      {onClose && (
        <button 
          className="btn btn-outline-secondary btn-sm"
          onClick={onClose}
          style={{ fontSize: '18px', lineHeight: '1' }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default FlipPanelHeader;
